<template>
	<v-dialog
		v-model="dialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon dark fab color="secondary" v-bind="attrs" v-on="on" class="mt-4">
				<v-icon large>mdi-information</v-icon>
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">製品・製造情報</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet elevation="0">
				<v-row no-gutters>
					<v-col cols="12" md="6" class="pa-sm-2 pa-1">
						<h6 class="text-h6 font-weight-bold">製品情報</h6>
						<table width="100%" class="mt-2 show-dialog-table">
							<tbody>
								<ShowDetailRecord :columnName="'注文番号'">
									<template v-slot:value>
										<a @click="matterDialog = true">
											{{ order_individual_info.ordered_product.matter.order_number }}
										</a>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'製造番号'">
									<template v-slot:value>
										<a @click="orderIndividualInfoDialog = true">
											{{ common.productNumberByOrderIndividualInfo(order_individual_info) }}
										</a>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord
									:columnName="'製品番号'"
									:value="order_individual_info.ordered_product.product.product_code"
								/>
								<ShowDetailRecord
									:columnName="'製品名'"
									:value="common.productNameWithSubName(order_individual_info.ordered_product)"
								/>
								<ShowDetailRecord :columnName="'図面・書類'">
									<template v-slot:value>
										<template v-if="files.length">
											<a
												class="d-block"
												v-for="file in files"
												:key="file.id"
												target="_blank"
												:href="file.url"
											>
												{{ file.file_name }}
											</a>
										</template>
										<template v-else>
											<span>なし</span>
										</template>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-col>
					<v-divider v-if="$vuetify.breakpoint.xs" class="my-4" />
					<v-col cols="12" md="6" class="pa-sm-2 pa-1">
						<h6 class="text-h6 font-weight-bold">製造情報</h6>
						<table width="100%" class="mt-2 show-dialog-table">
							<tbody>
								<ShowDetailRecord :columnName="'問題事例'">
									<template v-slot:value>
										<template v-if="problemCases.length">
											<a
												class="d-block"
												v-for="problemCase in problemCases"
												:key="problemCase.id"
												@click="
													$router.push({
														name: 'problem_case_show',
														params: { id: problemCase.id },
													})
												"
											>
												{{ problemCase.name }}
											</a>
										</template>
										<template v-else>
											<span>なし</span>
										</template>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-col>
				</v-row>
			</v-sheet>
		</v-card>
		<MatterShowDialog
			:id="order_individual_info.ordered_product.matter_id"
			:requiredFetch="true"
			v-if="matterDialog"
			@close="matterDialog = false"
		/>
		<OrderIndividualInfoShowDialog
			:id="order_individual_info.id"
			:dialog.sync="orderIndividualInfoDialog"
		/>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import MatterShowDialog from "../../matter/components/MatterShowDialog.vue"
import OrderIndividualInfoShowDialog from "../../order_individual_info/components/OrderIndividualInfoShowDialog.vue"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		id: {
			type: null,
			required: false,
		},
	},
	components: {
		MatterShowDialog,
		OrderIndividualInfoShowDialog,
		ShowDetailRecord,
	},
	data() {
		return {
			order_individual_info: {
				ordered_product: {
					matter: {
						files: [],
					},
					product: {},
				},
			},
			problemCases: [],
			files: [],
			isFetched: false,
			orderIndividualInfoDialog: false,
			matterDialog: false,
			common,
			dialog: false,
		}
	},
	methods: {
		fetchOrderIndividualInfo() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/order_individual_infos/${this.id}/problem_cases`
			axios
				.get(url, { headers })
				.then((res) => {
					// TODO
					this.order_individual_info = res.data.order_individual_info
					this.problemCases = res.data.problem_cases
					// this.files = TODO
					this.isFetched = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},

	watch: {
		dialog(newVal, _) {
			if (!this.isFetched) {
				this.fetchOrderIndividualInfo()
			}
		},
		deep: true,
	},
}
</script>
